import styled, { css } from "styled-components";
import { CardContainer, ImageContainer } from "../styles";
import {
  bigLabelTypographicStyle,
  smallLabelTypographicStyle,
} from "@/lib/styles/helpers";
import { H4, A } from "@/lib/styles";

export const ImageContainerLocation = styled(ImageContainer)`
  background-color: lightgray;
  order: 1;
  img {
    opacity: 0;
    transition: transform 0.1s ease-in, opacity 0.8s ease-in;

    ${({ $isLoaded }) =>
      $isLoaded &&
      css`
        opacity: 1;
      `}
  }
`;

export const CardContainerLocation = styled(CardContainer)`
  gap: 24px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Title = styled(H4)`
  order: 2;
`;

export const TitleLink = styled(A)`
  text-decoration: none;
  order: 2;

  &:hover {
    & ~ ${ImageContainerLocation} {
      img {
        transform: scale(1.1);
      }
    }

    color: ${({ theme }) => theme.colors.darkMiddle};
  }
`;

export const Subtitle = styled.p`
  ${bigLabelTypographicStyle}
  color: ${({ theme }) => theme.colors.darkMiddle};
`;

export const CardInfo = styled.div`
  order: 3;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  gap: 16px;

  ${({ theme }) => theme.mediaQueries.laptop} {
    gap: 18px;
  }
`;

export const LocationBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const LocationLink = styled.div`
  order: 4;
  padding-top: 1.5rem;
  border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.red};

  a {
    width: fit-content;
  }

    &:hover {
      & ~ ${ImageContainerLocation} {
        img {
          transform: scale(1.1);
        }
      }
    }
`;

export const IconWrapper = styled.div`
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  padding-bottom: 2px;
`;

export const LabelText = styled.p`
  ${smallLabelTypographicStyle}
  color: ${({ theme }) => theme.colors.darkMiddle};
  text-transform: uppercase;
`;

export const Address = styled.div`
  ${smallLabelTypographicStyle}
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
`;
export const Email = styled.div`
  ${smallLabelTypographicStyle}
  font-weight: 400;
  color: ${({ theme }) => theme.colors.red};
  text-decoration: none;
  cursor: pointer;
`;
export const Phone = styled.div`
  ${smallLabelTypographicStyle}
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
  cursor: auto;
`;
